module.exports = __webpack_public_path__ + "static/media/ff_model.789c740e.png";